const parseInfoUmfangPrivat = [
  {
    regEx: /familie|privat/i,
    result: 'P',
    tooltip: 'Privat'
  },
  {
    // workaround for missing negative lookbehind support, should be: /(?<!ohne )beruf/i
    regEx: /(?:(?!ohne ).{5}|^.{0,4})beruf/i,
    result: 'B',
    tooltip: 'Beruf'
  },
  {
    regEx: /(?:(?!ohne ).{5}|^.{0,4})(verk\.|verkehr|fahrzeug|fuhrpark)/i,
    result: 'V',
    tooltip: 'Verkehr'
  },
  {
    regEx: /(?:(?!ohne ).{5}|^.{0,4})(wohnung|wohnen|grundstück|miet)/i,
    result: 'W',
    tooltip: 'Wohnen'
  },
  {
    regEx: /miet-rechtsschutz vor gericht/i,
    result: 'M',
    tooltip: 'Mietrechtsschutz vor Gericht'
  }
];
const parseInfoUmfangPrivatPia = [
  {
    regEx: /^P/,
    result: 'P',
    tooltip: 'Privat'
  },
  {
    // workaround for missing negative lookbehind support, should be: /(?<!ohne )beruf/i
    regEx: /^.B/,
    result: 'B',
    tooltip: 'Beruf'
  },
  {
    regEx: /V/,
    result: 'V',
    tooltip: 'Verkehr'
  },
  {
    regEx: /W/,
    result: 'W',
    tooltip: 'Wohnen'
  },
  {
    regEx: /M/,
    result: 'M',
    tooltip: 'Mietrechtsschutz vor Gericht'
  },
  {
    regEx: /S&S/,
    result: 'Schnell & Sicher',
    tooltip: 'Schnell & Sicher'
  },
  {
    regEx: /FZ/,
    result: 'Fahrzeug',
    tooltip: 'Fahrzeug'
  }
];

const parseInfoUmfangGewerbe = [
  {
    regEx: /flotte/i,
    result: 'V',
    tooltip: 'Verkehr Gewerbe'
  },
  {
    regEx: /firmenrs/i,
    result: 'F',
    tooltip: 'Firmen Rechtsschutz'
  },
  {
    regEx: /GE\/|unbeb\.Grund/,
    result: 'I',
    tooltip: 'Immobilien Rechtsschutz'
  }
];

const parseInfoUmfangKomedexPia = [
  {
    regEx: /KOMedEX/i,
    result: 'KOMedEX',
    tooltip: 'KOMedEX'
  },
  {
    regEx: /G0003:Immobilie-gew./i,
    result: 'Immobilien(gew.)',
    tooltip: 'Immobilien(gew.)'
  },
  {   regEx: /G0006:Modul/i,
    result: 'Modul',
    tooltip: 'Modul'
  },
  {
    regEx: /G0007:Regress/i,
    result: 'Regress',
    tooltip: 'Regress'
  },
  {
    regEx: /:PRESTIGE/i,
    result: 'PRESTIGE',
    tooltip: 'PRESTIGE'
  },
  {
    regEx: /:Cyber/,
    result: 'Cyber',
    tooltip: 'Cyber-RS'
  },
];

const parseInfoUmfangAgromexPia = [
  {
    regEx: /AGROMEX/i,
    result: 'AGROMEX',
    tooltip: 'AGROMEX'
  },
  {
    regEx: /EXPERT/i,
    result: 'EXPERT',
    tooltip: 'EXPERT'
  },
  {
    regEx: /:PRESTIGE/i,
    result: 'PRESTIGE',
    tooltip: 'PRESTIGE'
  },
  {
    regEx: /:Cyber/,
    result: 'Cyber',
    tooltip: 'Cyber-RS'
  },
];

const parseInfoUmfangKompexPia = [
  {
    regEx: /KOMPEX-o.Immo./i,
    result: 'KOMPEX-o.Immo.',
    tooltip: 'KOMPEX ohne Immobilien-RS'
  },
  {
    regEx: /^KOMPEX$/i,
    result: 'KOMPEX',
    tooltip: 'KOMPEX'
  },{
    regEx: /KOMPEXplus/i,
    result: 'KOMPEXplus',
    tooltip: 'KOMPEXplus'
  },
  {
    regEx: /SSR-gew/i,
    result: 'Spezial-Straf-Rechtsschutz (gew.)',
    tooltip: 'Spezial-Straf-Rechtsschutz (gew.)'
  }, {
    regEx: /P0010:SSR/i,
    result: 'Spezial-Straf-Rechtsschutz (privat.)',
    tooltip: 'Spezial-Straf-Rechtsschutz (privat.)'
  },
  {
    regEx: /:PRESTIGE/i,
    result: 'PRESTIGE',
    tooltip: 'PRESTIGE'
  },
  {
    regEx: /:Cyber/,
    result: 'Cyber',
    tooltip: 'Cyber-RS'
  },
];

const parseInfoProduktPrivat = [
  {
    regEx: /standard/i,
    result: 'Standard'
  },
  {
    regEx: /expert/i,
    result: 'EXPERT'
  },
  {
    regEx: /prestige/i,
    result: 'PRESTIGE'
  }
];

const parseInfoProduktGeschaeft = [
  {
    regEx: /kompex/i,
    result: 'KOMPEX'
  },
  {
    regEx: /agromex/i,
    result: 'AGROMEX'
  },
  {
    regEx: /komedex/i,
    result: 'KOMedEX'
  },
  {
    regEx: /verein/i,
    result: 'Vereine'
  },
];
const parseInfoDeckungPrivat = [
  {
    regEx: /^P0001:Privat/,
    result: 'Privat'
  },
  {
    regEx: /P0002:Beruf/,
    result: 'Beruf'
  },
  {
    regEx: /P0003:Verkehr/,
    result: 'Verkehr'
  },
  {
    regEx: /P0004:Wohnung/,
    result: 'Wohnen'
  },
  {
    regEx: /P0010:SSR/,
    result: 'Spezial-Straf-Rechtsschutz'
  }
];

const parseInfoZusatzDeckung = [
  {
    regEx: /:EXPERT/,
    result: 'EXPERT'
  },
  {
    regEx: /:PRESTIGE/i,
    result: 'PRESTIGE'
  },
  {
    regEx: /:Cyber/,
    result: 'Cyber'
  },
  {
    regEx: /P0010:SSR/,
    result: 'Spezial-Straf-Rechtsschutz'
  }
];

export function getUmfangFromCategories(categories) {
  const sortedKeys = [];
  if (categories.includes("P")) {
    sortedKeys.push("P");
  }
  if (categories.includes("B")) {
    sortedKeys.push("B");
  }
  if (categories.includes("V")) {
    sortedKeys.push("V");
  }
  if (categories.includes("W")) {
    sortedKeys.push("W");
  }
  if (categories.includes("M")) {
    sortedKeys.push("M");
  }

  return sortedKeys.join(" ");
}


export function getUmfangFromDeckungen(deckungen) {
  const products = deckungen.map(d => d.produkt);
  let sortedKeys = [];
  if (products.includes("FIRM")) {
    sortedKeys.push("F");
  }
  if (products.includes("VERKA") || products.includes("VERKB") || products.includes("VERKC")) {
    sortedKeys.push("V");
  }
  if (products.includes("MIET")) {
    sortedKeys.push("I");
  }
  if (products.includes("SPEZ-PBV+MIET")) {
    sortedKeys = ["F", "V", "I", "P"];
  }
  if (products.includes("SPEZ-PBV")) {
    sortedKeys = ["F", "V", "P"];
  }

  return sortedKeys.join(" ");
}


export default {
  methods: {
    parse(input, parseInfo) {
      function checkSingleSearchInfo(previousResults, searchInfo) {
        if (searchInfo.regEx.test(input)) {
          previousResults.push(searchInfo.result);
        }
        return previousResults;
      }

      return parseInfo.reduce(checkSingleSearchInfo, []).join(' ');
    },
    parseTooltip(input, parseInfo) {
      function checkSingleSearchInfo(previousResults, searchInfo) {
        if (searchInfo.regEx.test(input)) {
          previousResults.push(searchInfo.tooltip);
        }
        return previousResults;
      }

      return parseInfo.reduce(checkSingleSearchInfo, []).join(' ');
    },
    deriveProduktInformation(bestandItem) {
      //debugger;
      switch (bestandItem.VertragsTyp) {
        case '0': {// Privatkunden
          if (bestandItem.Variante) { // PIA

            let umfang = this.parse(bestandItem.Variante, parseInfoUmfangPrivatPia);
            // parsing can produce too much entries for "M" - if "M" is found, "M" alone is correct
            if (umfang.indexOf("M") >= 0) {
              umfang = "M";
            }
            //PRESTIGE  EXPERT and Standard are part of Variante
            let privatProdukt = this.parse(bestandItem.Variante, parseInfoProduktPrivat);

            let deckung = this.parse(bestandItem.deckungen, parseInfoDeckungPrivat);
            let zusatzdeckung = this.parse(bestandItem.zusatzdeckungen, parseInfoZusatzDeckung);
            if(zusatzdeckung){
              if(deckung){
              deckung = deckung + ' ' + zusatzdeckung;
              } else {
                deckung = zusatzdeckung;
              }
            }
            if (!deckung) deckung = this.parseTooltip(bestandItem.Variante, parseInfoUmfangPrivatPia);
            return {
              produkt: privatProdukt,
              umfang,
              deckung
            };

          } else { // Altvertrag

            let umfang = this.parse(bestandItem.Produkt, parseInfoUmfangPrivat);
            // parsing can produce too much entries for "M" - if "M" is found, "M" alone is correct
            if (umfang.indexOf("M") >= 0) {
              umfang = "M";
            }
            //PRESTIGE is Part of produkt, EXPERT and Standard are part of Tarif
            let privatProdukt = (this.parse(bestandItem.Produkt, parseInfoProduktPrivat) === "PRESTIGE") ? "PRESTIGE" : this.parse(bestandItem.Tarif, parseInfoProduktPrivat);
            return {
              produkt: privatProdukt,
              umfang
            };
          }
        }
        case 'G': {// Gewerbe
          if (bestandItem.Variante) { // PIA
            const iskompex = /kompex/i.test(bestandItem.Produkt);
            const iskomedex = /komedex/i.test(bestandItem.Produkt);
            if(iskompex){
              return {
                produkt: 'KOMPEX',
                umfang: this.parse(bestandItem.Variante, parseInfoUmfangKompexPia),
                deckung: this.parse(bestandItem.zusatzdeckungen, parseInfoUmfangKompexPia)
              };
            } else if(iskomedex){
              return {
                produkt: 'KOMedEX',
                umfang: bestandItem.Variante,
                deckung: this.parse(bestandItem.deckungen + bestandItem.zusatzdeckungen, parseInfoUmfangKomedexPia)
              };
            } else {
              //PIA Gewerbe
              return {
                produkt: 'Gewerbe-RS',
                umfang: this.parse(bestandItem.deckungen, parseInfoUmfangGewerbe),
                deckung: this.parse(bestandItem.deckungen, parseInfoDeckungPrivat)
              };
            }
          } else { // Altvertrag
            const iskompex = /kompex/i.test(bestandItem.Produkt);
            return {
              produkt: iskompex ? 'KOMPEX' : 'Gewerbe-RS',
              umfang: this.parse(bestandItem.Produkt, parseInfoUmfangGewerbe)
            };
          }
        }
        default: {// Landwirtschaft, Ärzte
          const isagromex = /agromex/i.test(bestandItem.Produkt);
          const produkt = this.parse(bestandItem.Produkt, parseInfoProduktGeschaeft);
          if (bestandItem.Variante && isagromex ) { // PIA AGROMEX
              return {
                produkt: 'AGROMEX',
                umfang: bestandItem.Variante,
                deckung: this.parse(bestandItem.deckungen + bestandItem.zusatzdeckungen, parseInfoUmfangAgromexPia)
              };
          }
          return {
            produkt: produkt ? produkt : 'Sonstige',
            umfang: '-'
          };
        }
      }
    },
    getUmfangFromCategories,
    getUmfangFromDeckungen,
    allowEditVertrag(bestandItem) {
      return bestandItem.VertragsTyp === '0' && // only allow edit for "privat"
        bestandItem.Status !== "aufgehoben" &&
        bestandItem.Status !== "gekündigt" &&
        bestandItem.Status !== "abgelehnt" &&
        bestandItem.Status !== "nichteinlösung" &&
        bestandItem.Status !== "erloschen" &&
        bestandItem.Status !== "stillgelegt";
    }
  }
};
